import {
  timer as observableTimer,
  Observable
} from 'rxjs';
import { Component, OnDestroy, ElementRef, AfterContentInit } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { PaginationDTO } from '../../api/PaginationModel';
import {
  TenderDTO,
  WorkProcurementCommitteeDTO,
  ProcurementCommitteeState,
  TenderEnvelopeDTO,
  TenderStateDTO,
  TenderLotState,
  getSimpleIdentifierFromString
} from '../../api/plyca-dtos';
import { DossierDTO } from '../../api/plyca-dtos';

import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DossierService } from '../dossier.service';

import { EnvelopeDTO, CompanyDTO, ActionDefinitionDTO } from '../../api/plyca-dtos-v2';
import { finalize, switchMap, takeWhile, tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FocusTrapFactory } from '@angular/cdk/a11y';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';

import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';

class DecipherProcessResponse {
  finished: boolean;
  error: boolean;
}

@Component({
  selector: 'decipherProcess',
  templateUrl: 'decipherProcess.template.html'
})
export class decipherProcessComponent extends BaseComponent implements OnDestroy, AfterContentInit {

  tenderCommitteId: any;
  tenderCommitte: WorkProcurementCommitteeDTO;
  loaded = true;
  windowHash: string;
  tagsParent: string[];
  // INFORMACION DEL EXPEDIENTE
  dossier: DossierDTO;
  deciphering = false;
  status = '';
  avance = 0;
  title: string;
  time = '00:00';
  totalSeconds = 0;
  tenderList: Array<TenderDTO>;
  envelopes: Array<EnvelopeDTO>;
  errorEnvelopes: Map<CompanyDTO, TenderEnvelopeDTO[]>;
  private decipherObservable: Observable<any>;
  private cancelDecipherProcess = false;

  constructor(
    public plycaService: PlycaDataService,
    private headerActionsService: HeaderActionsService,
    public uiService: UIService,
    public dossierService: DossierService,
    public translateService: TranslateService,
    public helpService: HelpService,
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private focusTrap: FocusTrapFactory,
    private plycaErrorHandler: PlycaErrorHandler,
    private elem: ElementRef
  ) {
    super();

    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap(
        (storedHelpTags) => {
          this.tagsParent = storedHelpTags;
          return this.helpService.showContextHelpObservable(HelpType.DECIPHER_TENDER)
        }
      )));
    this.title = this.translateService.instant(
      'TenderEvent.TitleDecipherTenderProcess'
    );
    this.avance = 0;
    this.decipherObservable = observableTimer(2000).pipe(
      takeWhile(() => !this.cancelDecipherProcess),
      switchMap(() => this.checkTenders())
    );


    if (this.dialogConfig) {
      this.dossier = this.dialogConfig['dossier'];
      this.tenderCommitte = this.dialogConfig['tenderprocurementCommitteeDTO'];
      this.envelopes = this.dialogConfig['envelopes'];
      console.log('Sobres convocatoria', this.envelopes);
      this.tenderCommitteId = this.dialogConfig[
        'tenderprocurementCommitteeDTOId'
      ];
      if (
        this.tenderCommitte.procurementCommitteeDTO.state ===
        ProcurementCommitteeState.DECIPHER_IN_PROGRESS
      ) {
        // si se llega a la ventana con el estado descifrando (porque se haya cancelado, lanzamos la espera)
        this.decipher(false);
      } else if (
        this.tenderCommitte.procurementCommitteeDTO.state >
        ProcurementCommitteeState.QUORUM_OK
      ) {
        // si estamos en estado pendiente de descifrar (lo normal) se habilita la opcion de descifrar
        this.updateStatus(
          this.translateService.instant('TenderEvent.DecipherTenderStep1')
        );
      }
    }
  }

  ngAfterContentInit(): void {
    this.windowHash = generateRandomIdentifier();
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService.addWindowAction(
      'TenderEvent.decipherAction',
      'fa fa-unlock',
      'btn-warning ',
      true, this.windowHash
    ), success => {
      this.decipher();
    });
    this.headerActionsService.addWindowDivider(this.windowHash);
    this.addCloseAction();
    this.focusTrap.create(this.elem.nativeElement).focusLastTabbableElementWhenReady().then();
  }

  private addCloseAction() {
    this.subscribe(this.headerActionsService.addWindowAction('General.close', 'fas fa-times', 'btn-secondary', true, this.windowHash),
      success => {
        this.close();
      });
  }

  public decipher(launchDecipherProgress = true): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.addCloseAction();
    this.deciphering = true;
    this.updateStatus(
      this.translateService.instant('TenderEvent.dechiper.initProcess')
    );
    // pintar datos en pantalla
    this.subscribe(this.checkTenders(), () => {
      // iniciar proceso de consulta periodica
      this.startWaiting();
      if (launchDecipherProgress) {
        // lanzar descifrado
        console.log('lanzando descifrado...');
        this.subscribe(this.plycaService.decipherTenders(this.tenderCommitteId),
          (response: ActionDefinitionDTO) => {
            if (response?.identifier === 'NOK') {
              this.cancelDecipherProcess = true;
              this.ref.close();
              this.uiService.showMessage(response.description, this.translateService.instant('General.error'), 'errorStyle');
            }
          },
          (error: any) => this.plycaErrorHandler.showServerError(error)
        );
      }
    });
  }

  private startWaiting() {
    if (this.avance < 100) {
      this.subscribe(observableTimer(2000, 1000), () =>
        this.increaseTime()
      );
    }
  }

  private checkTenders(): Observable<any> {
    console.log('Consultando ofertas...');
    return this.plycaService.getDossierTenders(this.dossier.identifier).pipe(
      tap((param: PaginationDTO<TenderDTO>) => {
        // primer avance
        if ((this.avance = 0)) {
          this.avance = 10;
        }
        // datos de la tabla de ofertas
        let allTenders = param.content;
        if (allTenders && this.envelopes) {
          let openingEnvelopes = this.envelopes.map(openingEnvelope => openingEnvelope.identifier);
          // nos quedamos solo con las ofertas que han presentado algo para los sobres a descifrar
          this.tenderList = allTenders
            .filter(tender => tender.state !== TenderStateDTO.CANCELLED)
            .filter(tender => tender.tenderEnvelopes)
            .filter(tender => tender.state !== TenderStateDTO.REJECTED && tender.state !== TenderStateDTO.CANCELLED)
            .filter(tender => tender.tenderEnvelopes
              .map(tenderEnvelope => tenderEnvelope.envelope.identifier)
              .find(tenderEnvelopeId => openingEnvelopes
                .find(openingEnvelopeId => openingEnvelopeId === tenderEnvelopeId) !== undefined
              ) !== undefined);
        }
        this.calculateEnvelopeState();
      })
    );
  }

  close() {

    let data = new DecipherProcessResponse();
    data.finished = this.avance === 100;
    data.error = this.isDechiperProcessError();
    this.ref.close(data);
  }

  private increaseTime() {
    this.totalSeconds++;
    let minutes = Math.trunc(this.totalSeconds / 60);
    let seconds = this.totalSeconds % 60;
    this.time =
      this.padLeft('' + minutes, '0', 2) +
      ':' +
      this.padLeft('' + seconds, '0', 2);
  }

  padLeft(text: string, padChar: string, size: number): string {
    return (String(padChar).repeat(size) + text).substr(size * -1, size);
  }

  ngOnDestroy(): void {

    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {

        this.headerActionsService.clearWindowActions(this.windowHash);
        this.dialogConfig = null;
        this.ref = null;
        this.cancelDecipherProcess = true;
        super.ngOnDestroy();
      })));
  }

  updateStatus(newStatus: string) {
    this.status = newStatus;
  }
  public isLoaded(): boolean {
    return this.loaded;
  }

  public isDeciphering(): boolean {
    return this.deciphering;
  }

  private calculateEnvelopeState() {
    console.log(
      'calculando estado de sobres',
      this.envelopes,
      'y ofertas',
      this.tenderList
    );
    // indicar totales por tipo de sobre
    if (this.envelopes) {
      // iniciar sobres con errores
      this.errorEnvelopes = new Map();
      this.envelopes.forEach((env: EnvelopeDTO) => {
        console.log('Calculando totales sobre ', env.description);
        let tenderEnvelopeDecipheredCount = 0;
        let tenderEnvelopeNODecipheredCount = 0;
        let tenderEnvelopeErrors = 0;
        let tenderEnvelopeValidatedCount = 0;
        let tenderTotal = 0;
        // buscamos en cada oferta el sobre a tratar y vemos si ha descifrado o no
        this.tenderList.forEach(tender => {
          if (tender.tenderEnvelopes) {
            let envelope = tender.tenderEnvelopes.find(
              envTmp =>
                envTmp.envelope &&
                envTmp.envelope.identifier === env.identifier
            );
            // Si el expediente tiene lotes comprobar si el sobre de la oferta a descifrar tiene algún lote asociado aceptado
            // si no hay lotes no es necesario porque el servidor devuelve las ofertas aceptadas en su totalidad
            let envelopeLotIds = [];
            if (env.lots) {
              env.lots.forEach(envelopeToOpenLot => envelopeLotIds.push(envelopeToOpenLot.lotId));
            }
            if (env.lotGroups) {
              env.lotGroups.forEach(lotGroup => {
                if (lotGroup.lots) {
                  lotGroup.lots.forEach(envelopeToOpenLot => envelopeLotIds.push(envelopeToOpenLot.lotId));
                }
              });
            }
            let validEnvelope = true;
            if (envelopeLotIds.length > 0) {
              // comprobar si el lote de la oferta esta aceptado
              validEnvelope = false;
              if (tender.tendersLots) {
                validEnvelope = tender.tendersLots.find(
                  tenderLot => (tenderLot.state === TenderLotState.ADMITTED || tenderLot.state === TenderLotState.INITIAL) &&
                    // tslint:disable-next-line:triple-equals
                    envelopeLotIds.find(lotId => getSimpleIdentifierFromString(tenderLot.identifier) == lotId)) !== undefined;
              }
              if (!validEnvelope) {
                envelope = undefined;
              }
            }
            if (envelope) {
              tenderTotal++;
              if (envelope.decipher) {
                tenderEnvelopeDecipheredCount++;
              } else {
                if (envelope.decipherErrorMessage) {
                  tenderEnvelopeErrors++;
                  let companyErrEnvelope = this.errorEnvelopes.get(tender.company) || [];
                  companyErrEnvelope.push(envelope);
                  this.errorEnvelopes.set(tender.company, companyErrEnvelope);
                } else {
                  tenderEnvelopeNODecipheredCount++;
                }
              }
              // si esta descifrado comprobamos si se ha hecho la validacion de las firmas
              if (envelope.valid) {
                tenderEnvelopeValidatedCount++;
              }
            } else if (validEnvelope) {
              // si no encuentro el sobre en la oferta entendemos que no está descifrado (Applet)
              tenderEnvelopeNODecipheredCount++;
            }
          } else {
            // si la oferta no tiene sobres es que no se ha descifrado aun ninguno (Applet)
            tenderEnvelopeNODecipheredCount++;
          }
        });
        // almacenar en propiedades del sobre totales
        env['deciphered'] = tenderEnvelopeDecipheredCount;
        env['noDeciphered'] = tenderEnvelopeNODecipheredCount;
        env['errors'] = tenderEnvelopeErrors;
        env['validated'] = tenderEnvelopeValidatedCount;
        env['total'] = tenderTotal;
        console.log('descifrados ', tenderEnvelopeDecipheredCount);
        console.log('no descifrados ', tenderEnvelopeNODecipheredCount);
        console.log('validados ', tenderEnvelopeValidatedCount);
        console.log('total ', this.tenderList.length);
      });
    }
    // Comprobar totales de todos los sobres a descifrar
    let allEnvelopesDeciphered = true;
    let decipheredEnvelopesCount = 0;
    let decipheredEnvelopesErrorCount = 0;
    let totalEnvelopesToDecipher = 0;
    if (this.envelopes) {
      this.envelopes.forEach((envelope: EnvelopeDTO) => {
        decipheredEnvelopesCount += envelope['deciphered'];
        decipheredEnvelopesErrorCount += envelope['errors'];
        totalEnvelopesToDecipher += envelope['total'];
        if (envelope['deciphered'] + envelope['errors'] < envelope['total']) {
          allEnvelopesDeciphered = false;
        }
      });
    } else {
      allEnvelopesDeciphered = false;
    }
    console.log('allTendersDeciphered', allEnvelopesDeciphered);
    console.log('decipheredEnvelopesCount', decipheredEnvelopesCount);
    console.log('decipheredEnvelopesErrorCount', decipheredEnvelopesErrorCount);
    console.log('totalEnvelopesToDecipher', totalEnvelopesToDecipher);
    //
    if (totalEnvelopesToDecipher > 0 && decipheredEnvelopesCount + decipheredEnvelopesErrorCount < totalEnvelopesToDecipher) {
      this.avance = (100 * (decipheredEnvelopesCount + decipheredEnvelopesErrorCount)) / totalEnvelopesToDecipher + 10;
      this.updateStatus(
        this.translateService.instant('TenderEvent.dechiper.progress', {
          numoferta: decipheredEnvelopesCount + 1,
          total: totalEnvelopesToDecipher
        })
      );
      // volver a lanzar consulta de descifrado
      this.subscribe(this.decipherObservable);
    } else {
      this.avance = 100;
      if (this.isDechiperProcessError()) {
        this.updateStatus(
          this.translateService.instant('TenderEvent.dechiper.errorlist')
        );
      } else {
        this.updateStatus(
          this.translateService.instant('TenderEvent.dechiper.processs.finished')
        );
      }
    }

    // si estan todas descifradas mostrar mensaje
    if (allEnvelopesDeciphered) {
      if (decipheredEnvelopesErrorCount === 0) {
        this.uiService.showMessage(
          this.translateService.instant('TenderEvent.dechiper.processs.finished'),
          this.translateService.instant('General.info')
        );
      } else {
        this.uiService.showMessage(
          this.translateService.instant('TenderEvent.dechiper.processs.error'),
          this.translateService.instant('General.info')
        );
      }

    }
  }

  public isDechiperProcessError(): boolean {
    return this.errorEnvelopes && this.errorEnvelopes.size > 0;
  }

}
